import { z } from 'zod';

export const RoleEditValidatorSchema = z.object({
  defaultCultureId: z.string().optional(),
});

export type RoleEditValidator = z.infer<typeof RoleEditValidatorSchema>;
